import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"

export default function ActivityNotFoundPage() {
  const navigate = useNavigate()

  return (
    <section className="flex size-full flex-col items-center justify-center gap-4 px-4">
      <h1 className="font-muted-foreground">La actividad ingresada no es correcta o no existe.</h1>
      <Button variant="default" size="sm" onClick={() => navigate("/study")}>
        Volver
      </Button>
    </section>
  )
}
